import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCancelTodo({ id }: { id: number | string }) {
  const queryClient = useQueryClient()

  const action = async () => {
    const response = await httpClient.delete(`team/cash-flow/to-do/${id}`)
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Cancelled.')
      queryClient.invalidateQueries({ queryKey: ['todos'] })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
    },
    // onError: (error, variables) =>
    //   handleFormError({
    //     error,
    //     variables,
    //     setError,
    //     clientServerFieldMapping,
    //   }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
